import React from 'react';
import PropTypes from 'prop-types';

import {Box, Button, Dialog, DialogActions, DialogContent, DialogTitle} from 'views/components';
import {Dropdown, DropdownMenuItem, TextField, Typography} from 'views/components';
import {Translate, translate} from 'views/module';

const StageReasonDialog = (props) => {
  const {stage, onClose, onSave} = props;

  const [lostReason, setLostReason] = React.useState('');
  const [freeTextStatusReason, setFreeTextStatusReason] = React.useState('');

  const isClosedLost = stage === 'CLOSED_LOST';
  const lostReasons = Object.entries(translate('loomLead.ClosedLostReason'));
  const canSave = isClosedLost ? !!lostReason : !!freeTextStatusReason.trim();

  const save = () => {
    onSave(isClosedLost ? {lostReason} : {freeTextStatusReason: freeTextStatusReason.trim()});
  };

  return (
    <Dialog onClose={onClose} open>
      <DialogTitle onClose={onClose}>
        <Translate expression='loomLead.ChangeStatus.ReasonTitle' />
      </DialogTitle>
      <DialogContent>
        <Box sx={{mt: 1, minWidth: {sm: '28rem'}}}>
          <Typography sx={{mb: 2}}>
            <Translate
              expression='loomLead.ChangeStatus.ReasonPrompt'
              substitute={{status: translate(`loomLead.Status.${stage}.Title`)}}
            />
          </Typography>
          {
            isClosedLost &&
            <Dropdown
              onChange={setLostReason}
              value={lostReason}
              label={translate('loomLead.ChangeStatus.Reason')}
            >
              {
                lostReasons.map(([k, v]) => {
                  return (
                    <DropdownMenuItem key={k} value={k}>
                      {v.Title}
                    </DropdownMenuItem>
                  );
                })
              }
            </Dropdown>
          }
          {
            !isClosedLost &&
            <TextField
              autoFocus
              fullWidth
              multiline
              minRows={4}
              label={translate('loomLead.ChangeStatus.Reason')}
              placeholder={translate('loomLead.ChangeStatus.ReasonPlaceholder')}
              value={freeTextStatusReason}
              onChange={setFreeTextStatusReason}
            />
          }
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant='outlined' onClick={onClose}>
          <Translate expression='generic.Cancel' />
        </Button>
        <Button color='primary' onClick={save} disabled={!canSave}>
          <Translate expression='generic.Save' />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

StageReasonDialog.propTypes = {
  stage: PropTypes.oneOf(['CLOSED_LOST', 'INACTIVE']).isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};

export default StageReasonDialog;
